import React, { useState, useRef, useEffect } from "react";

import ReactCrop, {
  centerCrop,
  makeAspectCrop,
  // Crop,
  // PixelCrop,
  convertToPixelCrop,
} from "react-image-crop";
import { canvasPreview } from "./canvasPreview";
import { useDebounceEffect } from "./useDebounceEffect";
import "react-image-crop/dist/ReactCrop.css";
import './imageCrop.css';

export default function ImageCrop({ imgSrc, onCropComplete }) {
  const previewCanvasRef = useRef(null);
  const imgRef = useRef(null);
  const [crop, setCrop] = useState();
  const [completedCrop, setCompletedCrop] = useState();
  const [aspect, setAspect] = useState(16 / 9);
  const [isCroppingStarted, setIsCroppingStarted] = useState(false);

  function centerAspectCrop(mediaWidth, mediaHeight, aspect) {
    return centerCrop(
      makeAspectCrop(
        {
          unit: "%",
          width: 90,
        },
        aspect,
        mediaWidth,
        mediaHeight
      ),
      mediaWidth,
      mediaHeight
    );
  }
  function onImageLoad(e) {
    const { width, height } = e.currentTarget;

    // if (!aspect) {
      // Set full image crop as default
      const fullCrop = {
        unit: "%",
        x: 3,
        y: 0,
        width: 95,
        height: 100,
      };

      setCrop(fullCrop);
      setCompletedCrop(convertToPixelCrop(fullCrop, width, height));
    // } 
    // else {
    //   // Keep aspect crop
    //   setCrop(centerAspectCrop(width, height, aspect));
    // }
  }

  function handleToggleAspectClick() {
    if (aspect) {
      setAspect(undefined);
    } else {
      setAspect(16 / 9);

      if (imgRef.current) {
        const { width, height } = imgRef.current;
        const newCrop = centerAspectCrop(width, height, 16 / 9);
        setCrop(newCrop);
        // Updates the preview
        setCompletedCrop(convertToPixelCrop(newCrop, width, height));
      }
    }
  }
  useDebounceEffect(
    async () => {
      if (
        completedCrop?.width &&
        completedCrop?.height &&
        imgRef.current &&
        previewCanvasRef.current
      ) {
        // We use canvasPreview as it's much faster than imgPreview.
        canvasPreview(
          imgRef.current,
          previewCanvasRef.current,
          completedCrop
          // scale,
          // rotate,
        );
      }
    },
    100,
    [completedCrop]
  );
  useEffect(() => {
    handleToggleAspectClick();
  }, []);
  // imageCrop.jsx
  // Debounce the crop preview and JPEG generation to improve performance
  useDebounceEffect(
    () => {
      if (!completedCrop || !previewCanvasRef?.current || !imgRef?.current) {
        return;
      }

      const image = imgRef.current;
      const canvas = previewCanvasRef.current;
      const crop = completedCrop;

      const ctx = canvas.getContext("2d");

      if (!ctx) return;

      // Scale crop coordinates to the actual image size
      const scaleX = image.naturalWidth / image.width;
      const scaleY = image.naturalHeight / image.height;

      // Set canvas size to the cropped area's natural pixel size
      canvas.width = crop.width * scaleX;
      canvas.height = crop.height * scaleY;

      ctx.clearRect(0, 0, canvas.width, canvas.height);

      ctx.drawImage(
        image,
        crop.x * scaleX,
        crop.y * scaleY,
        crop.width * scaleX,
        crop.height * scaleY,
        0,
        0,
        canvas.width,
        canvas.height
      );
      const croppedImage = canvas?.toDataURL("image/png", 0.8);

      // Reduce JPEG quality to 0.8 for better performance
      onCropComplete(croppedImage);
    },
    200, // Debounce delay in ms
    [completedCrop, onCropComplete]
  );

  return (
    <div className="w-full h-full flex flex-col justify-center items-center gap-2">
      {!!imgSrc && (
        <ReactCrop
          crop={crop}
          onChange={(_, percentCrop) => setCrop(percentCrop)}
          onComplete={(c) => setCompletedCrop(c)}
          aspect={aspect}
          keepSelection={true}
          onDragStart={()=>{ setIsCroppingStarted(true)}}
          ruleOfThirds
          // circularCrop={true}
          minHeight={21}
          // circularCrop
        >
          <img
            ref={imgRef}
            alt="Crop me"
            src={imgSrc}
            // style={{ transform: `scale(${scale}) rotate(${rotate}deg)` }}
            onLoad={onImageLoad}
            crossOrigin="anonymous"
            className="h-[8rem] w-full object-contain"
          />
        </ReactCrop>
      )}
      {
        !isCroppingStarted ? 
        <div className="w-100% h-40 flex justify-center items-center">
          <img
            alt="Crop me"
            src={imgSrc}
            crossOrigin="anonymous"
            className="h-[8rem] w-full object-contain"
          />
          </div>:
      !!completedCrop && (
        <>
          <div className="w-100% h-40 flex justify-center items-center">
            <canvas
              ref={previewCanvasRef}
              style={{
                border: "1px solid black",
                objectFit: "contain",
                width: completedCrop.width,
                height: completedCrop.height,
              }}
            />
          </div>
        </>
      )}
    </div>
  );
}
